var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktopComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 32.87,
    viewBox: "0 0 36 32.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3581",
    "data-name": "Rectangle 3581",
    width: 36,
    height: 32.87,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4400",
    "data-name": "Group 4400",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4400-2",
    "data-name": "Group 4400",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    d: "M34.671,0H1.289A1.3,1.3,0,0,0,0,1.295V26.679a1.3,1.3,0,0,0,1.289,1.295h11.6v2.005H11.147a1.445,1.445,0,1,0,0,2.89H24.853a1.445,1.445,0,1,0,0-2.89h-1.7V27.974H34.711A1.3,1.3,0,0,0,36,26.679V1.336A1.331,1.331,0,0,0,34.671,0M16.624,25.408A1.376,1.376,0,1,1,18,26.772a1.38,1.38,0,0,1-1.376-1.364m16.763-2.966H2.613V2.6H33.387Z",
    transform: "translate(0 0)",
    fill: "#527991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    d: "M7.489,19.6h4.739a1.381,1.381,0,0,0,1.379-1.379V9.433a1.381,1.381,0,0,0-1.379-1.379H7.489A1.38,1.38,0,0,0,6.111,9.433v8.792A1.38,1.38,0,0,0,7.489,19.6",
    transform: "translate(-0.582 -0.766)",
    fill: "#527991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    d: "M18.268,10.31H31.037a1.128,1.128,0,0,0,0-2.256H18.268a1.128,1.128,0,1,0,0,2.256",
    transform: "translate(-1.633 -0.766)",
    fill: "#527991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    d: "M18.268,15.446H31.037a1.128,1.128,0,0,0,0-2.256H18.268a1.128,1.128,0,1,0,0,2.256",
    transform: "translate(-1.633 -1.255)",
    fill: "#527991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    d: "M18.268,20.582H31.037a1.128,1.128,0,0,0,0-2.256H18.268a1.128,1.128,0,1,0,0,2.256",
    transform: "translate(-1.633 -1.743)",
    fill: "#527991"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopComputer);
export default __webpack_public_path__ + "static/media/desktopComputer.8d1577eb.svg";
export { ForwardRef as ReactComponent };